"use strict";
/**
 * @file Created on 05.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");

var NThresholdPromoVolume_1 = require("./NThresholdPromoVolume");
/**
 * @author Tomas Leity
 */


var NThresholdPromoVolumeDTO =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NThresholdPromoVolumeDTO, _NotificationDoc_1$No);

  /**
   * @param products
   */
  function NThresholdPromoVolumeDTO(products) {
    var _this;

    _classCallCheck(this, NThresholdPromoVolumeDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NThresholdPromoVolumeDTO).call(this));
    _this.products = products;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NThresholdPromoVolumeDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NThresholdPromoVolumeDTO(mat.products);
    }
  }]);

  return NThresholdPromoVolumeDTO;
}(NotificationDoc_1.NotificationDoc);

exports.NThresholdPromoVolumeDTO = NThresholdPromoVolumeDTO;

NThresholdPromoVolumeDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NThresholdPromoVolumeDTO.name);
  return {
    products: builder.listOf(builder.obj('products', NThresholdPromoVolume_1.NThresholdPromoVolume.schema, function (mat) {
      return NThresholdPromoVolume_1.NThresholdPromoVolume.fromDataDict(mat);
    }))
  };
}();